<template>
  <div class="c-newsTag" :class="tagIndex">{{ text }}</div>
</template>

<script>
export default {
  props: {
    tagIndex: String,
    text: String,
  },
};
</script>

<style></style>
